// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TentangKamiRouteImport } from './routes/tentang-kami'
import { Route as SyaratKetentuanRouteImport } from './routes/syarat-ketentuan'
import { Route as SupplierLingerieSurabayaRouteImport } from './routes/supplier-lingerie-surabaya'
import { Route as SupplierBraLingerieSurabayaRouteImport } from './routes/supplier-bra-lingerie-surabaya'
import { Route as SupplierApdPabrikRouteImport } from './routes/supplier-apd-pabrik'
import { Route as StockingAppleCreamRouteImport } from './routes/stocking-apple-cream'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SarungTanganTuyayaRouteImport } from './routes/sarung-tangan-tuyaya'
import { Route as SarungTanganProyekRouteImport } from './routes/sarung-tangan-proyek'
import { Route as SarungTanganPaskibraRouteImport } from './routes/sarung-tangan-paskibra'
import { Route as SarungTanganPabrikRouteImport } from './routes/sarung-tangan-pabrik'
import { Route as SarungTanganNitrileRouteImport } from './routes/sarung-tangan-nitrile'
import { Route as SarungTanganMatahariRouteImport } from './routes/sarung-tangan-matahari'
import { Route as SarungTanganLupoRouteImport } from './routes/sarung-tangan-lupo'
import { Route as SarungTanganLatexNitrileRouteImport } from './routes/sarung-tangan-latex-nitrile'
import { Route as SarungTanganGekkoRouteImport } from './routes/sarung-tangan-gekko'
import { Route as SarungTanganDiamondRouteImport } from './routes/sarung-tangan-diamond'
import { Route as SarungTanganCometRouteImport } from './routes/sarung-tangan-comet'
import { Route as SarungTanganBulldozerRouteImport } from './routes/sarung-tangan-bulldozer'
import { Route as PusatGrosirRouteImport } from './routes/pusat-grosir'
import { Route as PrivasiRouteImport } from './routes/privasi'
import { Route as PiyamaLeisureRouteImport } from './routes/piyama-leisure'
import { Route as PerlengkapanMedisRouteImport } from './routes/perlengkapan-medis'
import { Route as PerlengkapanHajiUmrohRouteImport } from './routes/perlengkapan-haji-umroh'
import { Route as MinimumOrderRouteImport } from './routes/minimum-order'
import { Route as MerekRouteImport } from './routes/merek'
import { Route as MaskerOnemedRouteImport } from './routes/masker-onemed'
import { Route as MaskerCometRouteImport } from './routes/masker-comet'
import { Route as MansetBrillesRouteImport } from './routes/manset-brilles'
import { Route as KatalogRouteImport } from './routes/katalog'
import { Route as KaosKakiWintekuRouteImport } from './routes/kaos-kaki-winteku'
import { Route as KaosKakiTuyayaRouteImport } from './routes/kaos-kaki-tuyaya'
import { Route as KaosKakiOreoRouteImport } from './routes/kaos-kaki-oreo'
import { Route as KaosKakiGeleaRouteImport } from './routes/kaos-kaki-gelea'
import { Route as JaminanEkspedisiRouteImport } from './routes/jaminan-ekspedisi'
import { Route as HandukBreitexRouteImport } from './routes/handuk-breitex'
import { Route as GrosirUnderwearSurabayaRouteImport } from './routes/grosir-underwear-surabaya'
import { Route as GrosirPiyamaOnesetRouteImport } from './routes/grosir-piyama-oneset'
import { Route as GrosirPerlengkapanHajiUmrohRouteImport } from './routes/grosir-perlengkapan-haji-umroh'
import { Route as GrosirKesetKarpetRouteImport } from './routes/grosir-keset-karpet'
import { Route as GrosirKaosKakiRouteImport } from './routes/grosir-kaos-kaki'
import { Route as GrosirHandukRouteImport } from './routes/grosir-handuk'
import { Route as GrosirCdUnderwearRouteImport } from './routes/grosir-cd-underwear'
import { Route as EbookBikinTokoOnlineRouteImport } from './routes/ebook-bikin-toko-online'
import { Route as CdTallyRouteImport } from './routes/cd-tally'
import { Route as CdPoliniRouteImport } from './routes/cd-polini'
import { Route as CdPiaoliRouteImport } from './routes/cd-piaoli'
import { Route as CdOreoRouteImport } from './routes/cd-oreo'
import { Route as CdLupoRouteImport } from './routes/cd-lupo'
import { Route as CdHelloRouteImport } from './routes/cd-hello'
import { Route as CdHaodeRouteImport } from './routes/cd-haode'
import { Route as CdFemaRouteImport } from './routes/cd-fema'
import { Route as CariImportirRouteImport } from './routes/cari-importir'
import { Route as CaraJadiResellerRouteImport } from './routes/cara-jadi-reseller'
import { Route as CaraJadiDropshipperRouteImport } from './routes/cara-jadi-dropshipper'
import { Route as CamisolPoliniRouteImport } from './routes/camisol-polini'
import { Route as BraTallyRouteImport } from './routes/bra-tally'
import { Route as BraPoliniRouteImport } from './routes/bra-polini'
import { Route as BraPiaoliRouteImport } from './routes/bra-piaoli'
import { Route as BraOreoRouteImport } from './routes/bra-oreo'
import { Route as BraGuojisanRouteImport } from './routes/bra-guojisan'
import { Route as BraFengyuerRouteImport } from './routes/bra-fengyuer'
import { Route as BraDaililingRouteImport } from './routes/bra-daililing'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BikinTokoOnlineSendiriRouteImport } from './routes/bikin-toko-online-sendiri'
import { Route as BeritaRouteImport } from './routes/berita'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProdukIdRouteImport } from './routes/produk.$id'
import { Route as ProductIdRouteImport } from './routes/product.$id'
import { Route as LpManshetSarungTanganRouteImport } from './routes/lp.manshet-sarung-tangan'
import { Route as LpGrosirChar123slugChar125RouteImport } from './routes/lp.grosir-{$slug}'
import { Route as LpGrosirSarungTanganRouteImport } from './routes/lp.grosir-sarung-tangan'
import { Route as KategoriSlugRouteImport } from './routes/kategori.$slug'
import { Route as MerekIndexRouteImport } from './routes/merek.index'
import { Route as MerekSlugRouteImport } from './routes/merek.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogIdRouteImport } from './routes/blog.$id'
import { Route as BeritaIndexRouteImport } from './routes/berita.index'
import { Route as BeritaSlugRouteImport } from './routes/berita.$slug'
import { Route as BlogTagTagRouteImport } from './routes/blog.tag.$tag'

const TentangKamiRoute = TentangKamiRouteImport.update({
            id: '/tentang-kami',path: '/tentang-kami',getParentRoute: () => rootRouteImport
          })
const SyaratKetentuanRoute = SyaratKetentuanRouteImport.update({
            id: '/syarat-ketentuan',path: '/syarat-ketentuan',getParentRoute: () => rootRouteImport
          })
const SupplierLingerieSurabayaRoute = SupplierLingerieSurabayaRouteImport.update({
            id: '/supplier-lingerie-surabaya',path: '/supplier-lingerie-surabaya',getParentRoute: () => rootRouteImport
          })
const SupplierBraLingerieSurabayaRoute = SupplierBraLingerieSurabayaRouteImport.update({
            id: '/supplier-bra-lingerie-surabaya',path: '/supplier-bra-lingerie-surabaya',getParentRoute: () => rootRouteImport
          })
const SupplierApdPabrikRoute = SupplierApdPabrikRouteImport.update({
            id: '/supplier-apd-pabrik',path: '/supplier-apd-pabrik',getParentRoute: () => rootRouteImport
          })
const StockingAppleCreamRoute = StockingAppleCreamRouteImport.update({
            id: '/stocking-apple-cream',path: '/stocking-apple-cream',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SarungTanganTuyayaRoute = SarungTanganTuyayaRouteImport.update({
            id: '/sarung-tangan-tuyaya',path: '/sarung-tangan-tuyaya',getParentRoute: () => rootRouteImport
          })
const SarungTanganProyekRoute = SarungTanganProyekRouteImport.update({
            id: '/sarung-tangan-proyek',path: '/sarung-tangan-proyek',getParentRoute: () => rootRouteImport
          })
const SarungTanganPaskibraRoute = SarungTanganPaskibraRouteImport.update({
            id: '/sarung-tangan-paskibra',path: '/sarung-tangan-paskibra',getParentRoute: () => rootRouteImport
          })
const SarungTanganPabrikRoute = SarungTanganPabrikRouteImport.update({
            id: '/sarung-tangan-pabrik',path: '/sarung-tangan-pabrik',getParentRoute: () => rootRouteImport
          })
const SarungTanganNitrileRoute = SarungTanganNitrileRouteImport.update({
            id: '/sarung-tangan-nitrile',path: '/sarung-tangan-nitrile',getParentRoute: () => rootRouteImport
          })
const SarungTanganMatahariRoute = SarungTanganMatahariRouteImport.update({
            id: '/sarung-tangan-matahari',path: '/sarung-tangan-matahari',getParentRoute: () => rootRouteImport
          })
const SarungTanganLupoRoute = SarungTanganLupoRouteImport.update({
            id: '/sarung-tangan-lupo',path: '/sarung-tangan-lupo',getParentRoute: () => rootRouteImport
          })
const SarungTanganLatexNitrileRoute = SarungTanganLatexNitrileRouteImport.update({
            id: '/sarung-tangan-latex-nitrile',path: '/sarung-tangan-latex-nitrile',getParentRoute: () => rootRouteImport
          })
const SarungTanganGekkoRoute = SarungTanganGekkoRouteImport.update({
            id: '/sarung-tangan-gekko',path: '/sarung-tangan-gekko',getParentRoute: () => rootRouteImport
          })
const SarungTanganDiamondRoute = SarungTanganDiamondRouteImport.update({
            id: '/sarung-tangan-diamond',path: '/sarung-tangan-diamond',getParentRoute: () => rootRouteImport
          })
const SarungTanganCometRoute = SarungTanganCometRouteImport.update({
            id: '/sarung-tangan-comet',path: '/sarung-tangan-comet',getParentRoute: () => rootRouteImport
          })
const SarungTanganBulldozerRoute = SarungTanganBulldozerRouteImport.update({
            id: '/sarung-tangan-bulldozer',path: '/sarung-tangan-bulldozer',getParentRoute: () => rootRouteImport
          })
const PusatGrosirRoute = PusatGrosirRouteImport.update({
            id: '/pusat-grosir',path: '/pusat-grosir',getParentRoute: () => rootRouteImport
          })
const PrivasiRoute = PrivasiRouteImport.update({
            id: '/privasi',path: '/privasi',getParentRoute: () => rootRouteImport
          })
const PiyamaLeisureRoute = PiyamaLeisureRouteImport.update({
            id: '/piyama-leisure',path: '/piyama-leisure',getParentRoute: () => rootRouteImport
          })
const PerlengkapanMedisRoute = PerlengkapanMedisRouteImport.update({
            id: '/perlengkapan-medis',path: '/perlengkapan-medis',getParentRoute: () => rootRouteImport
          })
const PerlengkapanHajiUmrohRoute = PerlengkapanHajiUmrohRouteImport.update({
            id: '/perlengkapan-haji-umroh',path: '/perlengkapan-haji-umroh',getParentRoute: () => rootRouteImport
          })
const MinimumOrderRoute = MinimumOrderRouteImport.update({
            id: '/minimum-order',path: '/minimum-order',getParentRoute: () => rootRouteImport
          })
const MerekRoute = MerekRouteImport.update({
            id: '/merek',path: '/merek',getParentRoute: () => rootRouteImport
          })
const MaskerOnemedRoute = MaskerOnemedRouteImport.update({
            id: '/masker-onemed',path: '/masker-onemed',getParentRoute: () => rootRouteImport
          })
const MaskerCometRoute = MaskerCometRouteImport.update({
            id: '/masker-comet',path: '/masker-comet',getParentRoute: () => rootRouteImport
          })
const MansetBrillesRoute = MansetBrillesRouteImport.update({
            id: '/manset-brilles',path: '/manset-brilles',getParentRoute: () => rootRouteImport
          })
const KatalogRoute = KatalogRouteImport.update({
            id: '/katalog',path: '/katalog',getParentRoute: () => rootRouteImport
          })
const KaosKakiWintekuRoute = KaosKakiWintekuRouteImport.update({
            id: '/kaos-kaki-winteku',path: '/kaos-kaki-winteku',getParentRoute: () => rootRouteImport
          })
const KaosKakiTuyayaRoute = KaosKakiTuyayaRouteImport.update({
            id: '/kaos-kaki-tuyaya',path: '/kaos-kaki-tuyaya',getParentRoute: () => rootRouteImport
          })
const KaosKakiOreoRoute = KaosKakiOreoRouteImport.update({
            id: '/kaos-kaki-oreo',path: '/kaos-kaki-oreo',getParentRoute: () => rootRouteImport
          })
const KaosKakiGeleaRoute = KaosKakiGeleaRouteImport.update({
            id: '/kaos-kaki-gelea',path: '/kaos-kaki-gelea',getParentRoute: () => rootRouteImport
          })
const JaminanEkspedisiRoute = JaminanEkspedisiRouteImport.update({
            id: '/jaminan-ekspedisi',path: '/jaminan-ekspedisi',getParentRoute: () => rootRouteImport
          })
const HandukBreitexRoute = HandukBreitexRouteImport.update({
            id: '/handuk-breitex',path: '/handuk-breitex',getParentRoute: () => rootRouteImport
          })
const GrosirUnderwearSurabayaRoute = GrosirUnderwearSurabayaRouteImport.update({
            id: '/grosir-underwear-surabaya',path: '/grosir-underwear-surabaya',getParentRoute: () => rootRouteImport
          })
const GrosirPiyamaOnesetRoute = GrosirPiyamaOnesetRouteImport.update({
            id: '/grosir-piyama-oneset',path: '/grosir-piyama-oneset',getParentRoute: () => rootRouteImport
          })
const GrosirPerlengkapanHajiUmrohRoute = GrosirPerlengkapanHajiUmrohRouteImport.update({
            id: '/grosir-perlengkapan-haji-umroh',path: '/grosir-perlengkapan-haji-umroh',getParentRoute: () => rootRouteImport
          })
const GrosirKesetKarpetRoute = GrosirKesetKarpetRouteImport.update({
            id: '/grosir-keset-karpet',path: '/grosir-keset-karpet',getParentRoute: () => rootRouteImport
          })
const GrosirKaosKakiRoute = GrosirKaosKakiRouteImport.update({
            id: '/grosir-kaos-kaki',path: '/grosir-kaos-kaki',getParentRoute: () => rootRouteImport
          })
const GrosirHandukRoute = GrosirHandukRouteImport.update({
            id: '/grosir-handuk',path: '/grosir-handuk',getParentRoute: () => rootRouteImport
          })
const GrosirCdUnderwearRoute = GrosirCdUnderwearRouteImport.update({
            id: '/grosir-cd-underwear',path: '/grosir-cd-underwear',getParentRoute: () => rootRouteImport
          })
const EbookBikinTokoOnlineRoute = EbookBikinTokoOnlineRouteImport.update({
            id: '/ebook-bikin-toko-online',path: '/ebook-bikin-toko-online',getParentRoute: () => rootRouteImport
          })
const CdTallyRoute = CdTallyRouteImport.update({
            id: '/cd-tally',path: '/cd-tally',getParentRoute: () => rootRouteImport
          })
const CdPoliniRoute = CdPoliniRouteImport.update({
            id: '/cd-polini',path: '/cd-polini',getParentRoute: () => rootRouteImport
          })
const CdPiaoliRoute = CdPiaoliRouteImport.update({
            id: '/cd-piaoli',path: '/cd-piaoli',getParentRoute: () => rootRouteImport
          })
const CdOreoRoute = CdOreoRouteImport.update({
            id: '/cd-oreo',path: '/cd-oreo',getParentRoute: () => rootRouteImport
          })
const CdLupoRoute = CdLupoRouteImport.update({
            id: '/cd-lupo',path: '/cd-lupo',getParentRoute: () => rootRouteImport
          })
const CdHelloRoute = CdHelloRouteImport.update({
            id: '/cd-hello',path: '/cd-hello',getParentRoute: () => rootRouteImport
          })
const CdHaodeRoute = CdHaodeRouteImport.update({
            id: '/cd-haode',path: '/cd-haode',getParentRoute: () => rootRouteImport
          })
const CdFemaRoute = CdFemaRouteImport.update({
            id: '/cd-fema',path: '/cd-fema',getParentRoute: () => rootRouteImport
          })
const CariImportirRoute = CariImportirRouteImport.update({
            id: '/cari-importir',path: '/cari-importir',getParentRoute: () => rootRouteImport
          })
const CaraJadiResellerRoute = CaraJadiResellerRouteImport.update({
            id: '/cara-jadi-reseller',path: '/cara-jadi-reseller',getParentRoute: () => rootRouteImport
          })
const CaraJadiDropshipperRoute = CaraJadiDropshipperRouteImport.update({
            id: '/cara-jadi-dropshipper',path: '/cara-jadi-dropshipper',getParentRoute: () => rootRouteImport
          })
const CamisolPoliniRoute = CamisolPoliniRouteImport.update({
            id: '/camisol-polini',path: '/camisol-polini',getParentRoute: () => rootRouteImport
          })
const BraTallyRoute = BraTallyRouteImport.update({
            id: '/bra-tally',path: '/bra-tally',getParentRoute: () => rootRouteImport
          })
const BraPoliniRoute = BraPoliniRouteImport.update({
            id: '/bra-polini',path: '/bra-polini',getParentRoute: () => rootRouteImport
          })
const BraPiaoliRoute = BraPiaoliRouteImport.update({
            id: '/bra-piaoli',path: '/bra-piaoli',getParentRoute: () => rootRouteImport
          })
const BraOreoRoute = BraOreoRouteImport.update({
            id: '/bra-oreo',path: '/bra-oreo',getParentRoute: () => rootRouteImport
          })
const BraGuojisanRoute = BraGuojisanRouteImport.update({
            id: '/bra-guojisan',path: '/bra-guojisan',getParentRoute: () => rootRouteImport
          })
const BraFengyuerRoute = BraFengyuerRouteImport.update({
            id: '/bra-fengyuer',path: '/bra-fengyuer',getParentRoute: () => rootRouteImport
          })
const BraDaililingRoute = BraDaililingRouteImport.update({
            id: '/bra-daililing',path: '/bra-daililing',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BikinTokoOnlineSendiriRoute = BikinTokoOnlineSendiriRouteImport.update({
            id: '/bikin-toko-online-sendiri',path: '/bikin-toko-online-sendiri',getParentRoute: () => rootRouteImport
          })
const BeritaRoute = BeritaRouteImport.update({
            id: '/berita',path: '/berita',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProdukIdRoute = ProdukIdRouteImport.update({
            id: '/produk/$id',path: '/produk/$id',getParentRoute: () => rootRouteImport
          })
const ProductIdRoute = ProductIdRouteImport.update({
            id: '/product/$id',path: '/product/$id',getParentRoute: () => rootRouteImport
          })
const LpManshetSarungTanganRoute = LpManshetSarungTanganRouteImport.update({
            id: '/lp/manshet-sarung-tangan',path: '/lp/manshet-sarung-tangan',getParentRoute: () => rootRouteImport
          })
const LpGrosirChar123slugChar125Route = LpGrosirChar123slugChar125RouteImport.update({
            id: '/lp/grosir-{$slug}',path: '/lp/grosir-{$slug}',getParentRoute: () => rootRouteImport
          })
const LpGrosirSarungTanganRoute = LpGrosirSarungTanganRouteImport.update({
            id: '/lp/grosir-sarung-tangan',path: '/lp/grosir-sarung-tangan',getParentRoute: () => rootRouteImport
          })
const KategoriSlugRoute = KategoriSlugRouteImport.update({
            id: '/kategori/$slug',path: '/kategori/$slug',getParentRoute: () => rootRouteImport
          })
const MerekIndexRoute = MerekIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MerekRoute
          })
const MerekSlugRoute = MerekSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => MerekRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogIdRoute = BlogIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => BlogRoute
          })
const BeritaIndexRoute = BeritaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BeritaRoute
          })
const BeritaSlugRoute = BeritaSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BeritaRoute
          })
const BlogTagTagRoute = BlogTagTagRouteImport.update({
            id: '/tag/$tag',path: '/tag/$tag',getParentRoute: () => BlogRoute
          })





const BeritaRouteChildren = {
  BeritaSlugRoute: BeritaSlugRoute,BeritaIndexRoute: BeritaIndexRoute
}

const BeritaRouteWithChildren = BeritaRoute._addFileChildren(BeritaRouteChildren)




const BlogRouteChildren = {
  BlogIdRoute: BlogIdRoute,BlogIndexRoute: BlogIndexRoute,BlogTagTagRoute: BlogTagTagRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const MerekRouteChildren = {
  MerekSlugRoute: MerekSlugRoute,MerekIndexRoute: MerekIndexRoute
}

const MerekRouteWithChildren = MerekRoute._addFileChildren(MerekRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BeritaRoute: BeritaRouteWithChildren,BikinTokoOnlineSendiriRoute: BikinTokoOnlineSendiriRoute,BlogRoute: BlogRouteWithChildren,BraDaililingRoute: BraDaililingRoute,BraFengyuerRoute: BraFengyuerRoute,BraGuojisanRoute: BraGuojisanRoute,BraOreoRoute: BraOreoRoute,BraPiaoliRoute: BraPiaoliRoute,BraPoliniRoute: BraPoliniRoute,BraTallyRoute: BraTallyRoute,CamisolPoliniRoute: CamisolPoliniRoute,CaraJadiDropshipperRoute: CaraJadiDropshipperRoute,CaraJadiResellerRoute: CaraJadiResellerRoute,CariImportirRoute: CariImportirRoute,CdFemaRoute: CdFemaRoute,CdHaodeRoute: CdHaodeRoute,CdHelloRoute: CdHelloRoute,CdLupoRoute: CdLupoRoute,CdOreoRoute: CdOreoRoute,CdPiaoliRoute: CdPiaoliRoute,CdPoliniRoute: CdPoliniRoute,CdTallyRoute: CdTallyRoute,EbookBikinTokoOnlineRoute: EbookBikinTokoOnlineRoute,GrosirCdUnderwearRoute: GrosirCdUnderwearRoute,GrosirHandukRoute: GrosirHandukRoute,GrosirKaosKakiRoute: GrosirKaosKakiRoute,GrosirKesetKarpetRoute: GrosirKesetKarpetRoute,GrosirPerlengkapanHajiUmrohRoute: GrosirPerlengkapanHajiUmrohRoute,GrosirPiyamaOnesetRoute: GrosirPiyamaOnesetRoute,GrosirUnderwearSurabayaRoute: GrosirUnderwearSurabayaRoute,HandukBreitexRoute: HandukBreitexRoute,JaminanEkspedisiRoute: JaminanEkspedisiRoute,KaosKakiGeleaRoute: KaosKakiGeleaRoute,KaosKakiOreoRoute: KaosKakiOreoRoute,KaosKakiTuyayaRoute: KaosKakiTuyayaRoute,KaosKakiWintekuRoute: KaosKakiWintekuRoute,KatalogRoute: KatalogRoute,MansetBrillesRoute: MansetBrillesRoute,MaskerCometRoute: MaskerCometRoute,MaskerOnemedRoute: MaskerOnemedRoute,MerekRoute: MerekRouteWithChildren,MinimumOrderRoute: MinimumOrderRoute,PerlengkapanHajiUmrohRoute: PerlengkapanHajiUmrohRoute,PerlengkapanMedisRoute: PerlengkapanMedisRoute,PiyamaLeisureRoute: PiyamaLeisureRoute,PrivasiRoute: PrivasiRoute,PusatGrosirRoute: PusatGrosirRoute,SarungTanganBulldozerRoute: SarungTanganBulldozerRoute,SarungTanganCometRoute: SarungTanganCometRoute,SarungTanganDiamondRoute: SarungTanganDiamondRoute,SarungTanganGekkoRoute: SarungTanganGekkoRoute,SarungTanganLatexNitrileRoute: SarungTanganLatexNitrileRoute,SarungTanganLupoRoute: SarungTanganLupoRoute,SarungTanganMatahariRoute: SarungTanganMatahariRoute,SarungTanganNitrileRoute: SarungTanganNitrileRoute,SarungTanganPabrikRoute: SarungTanganPabrikRoute,SarungTanganPaskibraRoute: SarungTanganPaskibraRoute,SarungTanganProyekRoute: SarungTanganProyekRoute,SarungTanganTuyayaRoute: SarungTanganTuyayaRoute,SearchRoute: SearchRoute,StockingAppleCreamRoute: StockingAppleCreamRoute,SupplierApdPabrikRoute: SupplierApdPabrikRoute,SupplierBraLingerieSurabayaRoute: SupplierBraLingerieSurabayaRoute,SupplierLingerieSurabayaRoute: SupplierLingerieSurabayaRoute,SyaratKetentuanRoute: SyaratKetentuanRoute,TentangKamiRoute: TentangKamiRoute,KategoriSlugRoute: KategoriSlugRoute,LpGrosirSarungTanganRoute: LpGrosirSarungTanganRoute,LpGrosirChar123slugChar125Route: LpGrosirChar123slugChar125Route,LpManshetSarungTanganRoute: LpManshetSarungTanganRoute,ProductIdRoute: ProductIdRoute,ProdukIdRoute: ProdukIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)